import { DateDailyFieldProps } from './interface'

export function withDateDailyField(Component: React.FC<DateDailyFieldProps>) {
  function Hoc(props: DateDailyFieldProps) {
    return <Component {...props} />
  }
  return Hoc
}
